import { getItem } from 'owa-local-storage';
import { setTrySuggestionsCount } from './setTrySuggestionsData';
import {
    TRY_SUGGESTION_DISPLAY_COUNT_STRING,
    TRY_SUGGESTION_CLICK_COUNT_STRING,
    TRY_SUGGESTION_IDS_STRING,
} from '../searchConstants';
import { TrySuggestionCountType } from '../store/schema/TrySuggestionCountType';

export function getTrySuggestionsCount(SuggestionCountType: TrySuggestionCountType): number {
    let key;
    switch (SuggestionCountType) {
        case TrySuggestionCountType.Display:
            key = TRY_SUGGESTION_DISPLAY_COUNT_STRING;
            break;
        case TrySuggestionCountType.Click:
            key = TRY_SUGGESTION_CLICK_COUNT_STRING;
            break;
    }
    const getTrySuggestionCount = getItem(window, key);
    if (!getTrySuggestionCount) {
        setTrySuggestionsCount(SuggestionCountType, 0);
        return 0;
    }
    return parseInt(getTrySuggestionCount);
}

export function getExcludedTrySuggestionIds() {
    return getItem(window, TRY_SUGGESTION_IDS_STRING);
}
